import { render, staticRenderFns } from "./expoExhibitor.vue?vue&type=template&id=3470f71d&scoped=true"
import script from "./expoExhibitor.vue?vue&type=script&lang=js"
export * from "./expoExhibitor.vue?vue&type=script&lang=js"
import style0 from "./expoExhibitor.vue?vue&type=style&index=0&id=3470f71d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3470f71d",
  null
  
)

export default component.exports